export const ClientBookingPeriods = {
  en: {
    'Select a date to see available times':
      'Select a date to see available times',
    'No available times for this date': 'No available times for this date',
    'Select time': 'Select time',
  },
  uk: {
    'Select a date to see available times':
      'Оберіть дату, щоб побачити доступний час',
    'No available times for this date': 'Немає доступного часу на цю дату',
    'Select time': 'Оберіть час',
  },
};
